<template>
  <div
    id="videoPLayer"
    class="fullScreen"
    @click="click"
    @touchStart.prevent.stop.capture
  >
    <vp
      class="video-player-box vjs-big-play-centered"
      :class="fullScreen ? '' : 'hideLeftIcon'"
      ref="videoPlayer"
      :options="playerOptions"
      :playsinline="true"
      @ready="ready"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
      @ended="onPlayerEnded($event)"
      @loadeddata="onPlayerLoadeddata($event)"
      @waiting="onPlayerWaiting($event)"
      @playing="onPlayerPlaying($event)"
      @timeupdate="onPlayerTimeupdate($event)"
      @canplay="onPlayerCanplay($event)"
      @canplaythrough="onPlayerCanplaythrough($event)"
      @statechanged="playerStateChanged($event)"
      @error="playerError($event)"
      @fullscreenchange="fullFn($event)"
    >
    </vp>
    <!-- 休息遮罩 -->
    <!-- <div v-if="showRest" class="mask" :class="[fullScreen ? 'fullScreen' : '']">
      <div>
        <span class="time" v-for="(time,key) in timeList" :key="key" >{{time}}</span>
      </div>
      <div class="footer">
        <div class="btn" @click="handleRestMore">再休息30秒</div>
        <div class="btn" @click="handleSkipRest">跳过休息</div>
      </div>
    </div> -->
    <!-- 暂停遮罩  pauseStatus-->
    <!-- <div v-if="pauseStatus" class="wrap">
        <div class="pause" @click="continuePlay"></div>
        <p>{{descText}}</p>
    </div> -->
    <!-- 网络异常 -->
    <!-- <div v-if="netStatus" class="mask_1" :class="[fullScreen ? 'fullScreen' : '']" @click.stop.prevent>
        <div class="net_error" @click="netRefresh">
          <div class="desc_1">网络请求异常</div>
          <div class="desc_2">点击重试</div>
        </div>
    </div> -->
    <!-- 非wifi情况下 tipNet-->
    <!-- <div v-if="false" class="mask_1" :class="[fullScreen ? 'fullScreen' : '']" @click.stop.prevent>
        <div class="net_status">
          <div class="container">
            <div class="inner_container">
              <div class="top_part">
                <div class="title">您正在使用5G网络，预计该视频会消耗您1M流量，确定要继续观看吗？</div>
                <div class="title_1">
                  <div class="check_box">
                    <van-checkbox v-model="checked" shape="square" checked-color="#ff8400" icon-size="12px" @click.stop.prevent="checkboxClick"></van-checkbox>
                  </div>
                  <div class="tip">以后直接播放，不再提醒</div>
                </div>
              </div>
              <div class="bot_part">
                <div class="close" @click.stop.prevent="cancelPlay">取消</div>
                <div class="next" @click.stop.prevent="surePlay">确认</div>
              </div>
            </div>
          </div>
        </div>
    </div> -->
    <!-- 实时显示运动参数 -->
    <!-- <div v-if="playEnd && contentType === 4 && !isOnlyLook" class="consume">
      <div>卡路里：{{actualBurnKcal | num}}千卡</div>
      <div>运动量：{{sportNum}}</div>
    </div> -->
  </div>
</template>
<script>
import 'video.js/dist/video-js.css';
import vp from './v1';
import videojs from 'video.js';

const Component = videojs.getComponent('Component');

export default {
  name: 'video-player',
  components: {
    vp,
  },
  props: {
    title: {
      type: String,
      default() {
        return '无标题';
      },
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    videoInfo: { // 单个视频详情
      type: Object,
      default() {
        return {};
      },
    },
    met: { // 计算卡路里met参数
      type: Number,
      default: 0,
    },
    contentType: {
      type: Number,
      default: 0,
    },
    isOnlyLook: { // 是否只能查看
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      networkType: '',//网络类型
      tipNet: false,//流量警告提醒
      checked: false,
      fullScreen: false,
      playing: false,
      playerOptions: {
        // videojs options
        fill: true,
        //读取视频第一帧作为封面
        techCanOverridePoster: true,
        suppressNotSupportedError: true,
        // fluid: true,
        muted: false,
        language: 'zh',
        playbackRates: false,
        autoSetup: true,
        autoplay: false,
        preload: 'auto',
        sources: [],
        bigPlayButton: true,
        controls: true,
        preferFullWindow: true,
        controlBar: {
          children: [
            {
              name: 'playToggle',
            },
            {
              name: 'currentTimeDisplay',
            },
            {
              name: 'progressControl',
            },
            {
              name: 'durationDisplay',
            },
          ],
        },
      },
      showRest: false,
      pauseStatus: false,//播放按钮出现
      descText: '',
      netStatus: false,//网络异常的时候出现刷新的弹框
      sportNum: 0, // 运动量
      actualBurnKcal: 0, // 消耗卡路里
      rest: {
        current: 30, // 当前剩余休息时间
        disabled: false,
      },
      timer: null,
      playEnd: false,
      playTimes: 0, // 视频循环次数
    };
  },
  filters: {
    num(num) {
      return num.toFixed(2);
    },
  },
  watch: {
    options: {
      deep: true,
      handler(v) {
        this.playerOptions = videojs.mergeOptions(this.playerOptions, v);
      },
      immediate: true,
    },
    showRest(val) {
      if (val) {
        this.restCountdown();
      }
    },
  },
  mounted() {
    // 播放的时候判断网络，如果非wifi，谭康提示
    this.getNetworkType();
    // 非wifi暂停播放
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    weight() {
      return this.$store.state.user.userInfo.weight;
    },
    timeList() {
      if (this.rest.current >= 10) {
        return String(this.rest.current).split('');
      } else {
        return [String(this.rest.current)];
      }
    },
    // 休息节点
    // pauseArr () {
    //   let arr  = [];
    //   for (let i = 1; i <= Number(this.videoInfo.groups); i++) {
    //     arr.push({
    //       time: Number(this.videoInfo.movementTime) * Number(this.videoInfo.numEachGroup) * i,
    //       isPlayOver: false
    //     });
    //   }
    //   return arr;
    // },
    // 运动量节点
    timeNode() {
      let arr = [];
      for (let j = 1; j <= Number(this.videoInfo.numEachGroup); j++) {
        arr.push({
          time: j * Number(this.videoInfo.movementTime),
          isPlayOver: false,
        });
      }
      return arr;
    },
  },
  methods: {

    fullFn(player) {
      // debugger
    },
    // 获取当前的网络
    getNetworkType() {
      let ua = navigator.userAgent;
      let networkStr = ua.match(/NetType\/\w+/) ? ua.match(/NetType\/\w+/)[0] : 'NetType/other';
      networkStr = networkStr.toLowerCase().replace('nettype/', '');
      switch (networkStr) {
        case 'wifi':
          this.networkType = 'wifi';
          this.tipNet = false;
          break;
        case '4g':
          this.networkType = '4g';
          this.tipNet = true;
          break;
        case '3g':
          this.networkType = '3g';
          this.tipNet = true;
          break;
        case '3gnet':
          this.networkType = '3g';
          this.tipNet = true;
          break;
        case '2g':
          this.networkType = '2g';
          this.tipNet = true;
          break;
        default:
          this.networkType = 'unKnow';
          this.tipNet = true;
          break;
      }
    },
    // 流量情况下暂停播放
    cancelPlay() {
      this.tipNet = false;
      // this.player.pause()
    },
    // 流量情况下继续播放
    surePlay() {
      this.tipNet = false;
      this.player.play();
    },
    checkboxClick() {

    },
    // 网络异常的时候重新刷新加载
    netRefresh() {
    },
    handleRestMore() {
      // 只能多休息30秒，点击过后将按钮置灰，时间到了直接关闭遮罩，继续播放视频
      if (this.rest.disabled) {
        return;
      }
      this.rest.disabled = true;
      this.rest.current += 30;
    },
    handleSkipRest() {
      clearInterval(this.timer);
      // 关闭休息遮罩，继续播放视频
      this.showRest = false;
      // this.player.play();
      this.playerOptions.autoplay = true;
      // 重置rest对象
      this.rest.current = 30;
      this.rest.disabled = false;
    },
    // 休息倒计时
    restCountdown() {
      this.timer = setInterval(() => {
        this.rest.current -= 1;
        if (this.rest.current <= 0) {
          clearInterval(this.timer);
          // 关闭休息遮罩，继续播放视频
          this.showRest = false;
          this.playerOptions.autoplay = true;
          // this.player.play();
          // 重置rest对象
          this.rest.current = 30;
          this.rest.disabled = false;
        }
      }, 1000);
    },
    click(e) {
      // 当显示休息遮罩层时，不允许点击
      if (this.showRest) {
        return;
      }
      // this.playing ? this.player.pause() : this.player.play();
    },
    // 播放视频
    autoPlayVideo() {
      this.player.play();
    },
    ready(player) {
      const vm = this;
      setTimeout(() => {
        this.createCustomFullScreen();
        this.createCustomTitle();
        this.createCustomPercent();
      });
      this.patchRotateBug();
      // 默认播放
      this.player.play();
      // wifi下默认播放，其他暂停，弹框提示
      if (this.networkType != 'wifi') {
        // this.player.pause()
      } else {
        this.player.play();
      }
      this.$emit('ready', player, this);
    },
    createCustomPercent() {
      const vm = this;
      const customPercent = videojs.extend(Component, {
        constructor(player, options) {
          Component.apply(this, arguments);
          this.player = player;
          this.duration = '';
          this.regEvt();
          this.updateContent();
        },
        regEvt() {
          this.player.on('loadeddata', () => {
            this.duration = this.player.duration();
            this.updateContent();
            this.player.on('seeked', () => {
              this.pauseStatus = false;
              this.player.play();
              // vm.descText = '认真观看完毕才能学会哦！坚持一下'
              // vm.pauseStatus = true
              // setTimeout(() => {
              //    vm.pauseStatus = false
              // }, 2500);
              this.updateContent();
            });
            this.player.on('seeking', () => {
              this.pauseStatus = false;
              // this.player.play()
              // vm.descText = '认真观看完毕才能学会哦！坚持一下'
              // vm.pauseStatus = true
              this.updateContent();
            });

          });
        },
        createEl() {
          return videojs.dom.createEl('div', {
            className: 'vjs-custom-percent dn',
          });
        },
        updateContent() {
          // let currentTime =
          //   parseInt(this.player.currentTime()) || this.player.currentTime();
          // let duration = parseInt(this.duration) || this.duration;
          videojs.dom.emptyEl(this.el());
          let cur = vm.$refs.videoPlayer.$el.querySelector(
            '.vjs-current-time-display',
          ).innerHTML;
          let dur = vm.$refs.videoPlayer.$el.querySelector(
            '.vjs-duration-display',
          ).innerHTML;
          const currentTimeDom = videojs.dom.createEl('div', {
            className: 'vjs-custom-percent-inner',
            innerHTML: `
              <span class="vjs-custom-percent-inner-cur">${ cur }</span>
              <span class="vjs-custom-percent-inner-gutter">/</span>
              <span class="vjs-custom-percent-inner-dur">${ dur }</span>
            `,
          });
          videojs.dom.appendContent(this.el(), currentTimeDom);
        },
      });
      const customPercentInstence = new customPercent(this.player, {});
      this.player.addChild(customPercentInstence);
    },
    createCustomTitle() {
      const vm = this;
      const TitleBar = videojs.extend(Component, {
        constructor: function(player, options) {
          Component.apply(this, arguments);
          if (options.text) {
            this.updateTextContent(options.text);
          }
        },

        createEl: function() {
          return videojs.dom.createEl('div', {
            className: 'vjs-title-bar dn',
          });
        },
        updateTextContent: function(text) {
          if (typeof text !== 'string') {
            text = '无标题';
          }
          if (this.el()) {
            videojs.dom.emptyEl(this.el());
            let titleLWrap = videojs.dom.createEl('span', {
              className: 'vjs-title-bar-left-wrap',
            });
            let titleLIcon = videojs.dom.createEl('span', {
              className: 'vjs-title-bar-left-icon',
            });
            let titleText = videojs.dom.createEl('span', {
              className: 'vjs-title-bar-left-text',
            });
            videojs.dom.appendContent(titleLWrap, titleLIcon);
            videojs.dom.appendContent(titleLWrap, titleText);
            videojs.dom.appendContent(titleText, text);
            videojs.dom.appendContent(this.el(), titleLWrap);
            videojs.dom.appendContent(this.el());
            this.addChild('VolumePanel', {
              inline: false,
              vertical: false,
            });
            this.updateEvent();
          }
        },
        updateEvent() {
          let titleDomWrap = this.$('.vjs-title-bar-left-wrap');
          let click = (e) => {
            e.stopPropagation();
            vm.$emit('titleClick', e, vm.player, vm);
          };
          titleDomWrap.addEventListener('click', click);
        },
      });

      const titleBar = new TitleBar(this.player, {
        text: this.title,
      });

      const w = this.$watch(
        () => this.title,
        () => {
          titleBar.updateTextContent(this.title);
        },
      );
      this.recoverTitleBar_ = () => {
        w();
      };
      this.player.addChild(titleBar);
    },
    createCustomFullScreen() {
      const vm = this;
      const Button = videojs.getComponent('Button');
      const customFullScreen = videojs.extend(Button, {
        constructor() {
          Button.apply(this, arguments);
          this.addClass('vjs-control-custom-full-screen');
          this.controlText('全屏');
        },
        handleClick(e) {
          vm.setFullScreen(!vm.fullScreen);
        },
      });
      this.player.controlBar.addChild(new customFullScreen(this.player));
    },
    setFullScreen(v) {
      this.fullScreen = v;
    },
    getFullScreen() {
      return this.fullScreen;
    },
    patchRotateBug() {
      let vm = this;
      let seekBar = this.player.controlBar.ProgressControl.seekBar;
      let calculateDistance = seekBar.calculateDistance;
      seekBar.calculateDistance = function(event) {
        if (vm.fullScreen) {
          function findPosition(el) {
            if (!el || (el && !el.offsetParent)) {
              return {
                left: 0,
                top: 0,
                width: 0,
                height: 0,
              };
            }
            const width = el.offsetWidth;
            const height = el.offsetHeight;
            let left = 0;
            let top = 0;

            while (
              el.offsetParent &&
              el !== document[vm.player.fsApi_.fullscreenElement]
              ) {
              left += el.offsetLeft;
              top += el.offsetTop;

              el = el.offsetParent;
            }

            return {
              left,
              top,
              width,
              height,
            };
          }

          const getPointerPosition = function(el, event) {

            const position = {};
            const boxTarget = findPosition(event.target);
            const box = findPosition(el);
            const boxW = box.width;
            const boxH = box.height;
            let offsetY = event.offsetY - (box.top - boxTarget.top);
            let offsetX = event.offsetX - (box.left - boxTarget.left);

            if (event.changedTouches) {
              offsetX = event.changedTouches[0].pageY - box.left;
              offsetY = event.changedTouches[0].pageY - box.top;
            }

            position.y = 1 - Math.max(0, Math.min(1, offsetY / boxH));
            position.x = Math.max(0, Math.min(1, offsetX / boxW));
            return position;
          };
          const position = getPointerPosition(this.el_, event);
          if (this.vertical()) {
            return position.y;
          }
          return position.x;
        } else {
          return calculateDistance.apply(this, arguments);
        }
      };
    },
    // listen event
    onPlayerPlay(player) {
      this.playEnd = true;
      this.$emit('onPlayerPlay', player, this);
    },
    // 点击了暂停后，显示弹出层
    onPlayerPause(player) {
      // 显示播放按钮
      this.descText = '点击屏幕中播放按钮可直接播放';
      this.pauseStatus = true;
      this.playing = false;
      this.$emit('onPlayerPause', player, this);
    },
    // 点击播放按钮，继续播放
    continuePlay() {
      this.pauseStatus = false;
      this.player.play();
    },
    onPlayerEnded(player) {
      // 做完一组训练，并且该组动作不是最后一组，暂停视频，显示遮罩
      this.playTimes += 1;
      if (this.playTimes < this.videoInfo.groups) {
        this.showRest = true;
        // 重置时间节点状态
        this.timeNode.map(item => item.isPlayOver = false);
        return;
      }
      // 视频播放完成，关闭运动量遮罩
      this.playEnd = false;
      // this.$emit("onPlayerEnded", player, this);
      this.$emit('onPlayerEnded', this.fullScreen, this.actualBurnKcal);
    },
    onPlayerLoadeddata(player) {
      this.$emit('onPlayerLoadeddata', player, this);
    },
    onPlayerWaiting(player) {
      this.$emit('onPlayerWaiting', player, this);
    },
    onPlayerPlaying(player) {
      this.playing = true;
      this.$emit('onPlayerPlaying', player, this);
    },
    onPlayerTimeupdate(player) {
      if (!this.isOnlyLook) {
        //视频播放时间
        let time = player.currentTime();
        this.timeNode.map(item => {
          if (time >= (item.time + 8) && !item.isPlayOver) {
            item.isPlayOver = true;
            // 运动量增加1
            this.sportNum += 1;
            // 计算实际消耗kcal METs*3.5*体重kg/200*时长min
            this.actualBurnKcal = this.met * 3.5 * this.weight / 200 *
              ((time - 8 + this.playTimes * this.videoInfo.movementTime *
                this.videoInfo.numEachGroup) / 60);
          }
        });
      }
      this.$emit('onPlayerTimeupdate', player, this);
    },
    onPlayerCanplay(player) {
      this.$emit('onPlayerCanplay', player, this);
    },
    onPlayerCanplaythrough(player) {
      this.$emit('onPlayerCanplaythrough', player, this);
    },
    playerError(player) {
      // 播放异常，弹框提示
      // this.netStatus = true
      // this.pauseStatus = false
      this.$emit('onPlayerError', player, this);
    },
    // or listen state event
    playerStateChanged(playerCurrentState) {
      this.$emit('playerStateChanged', playerCurrentState, this.player, this);
    },
  },
  destroyed() {
    this.recoverTitleBar_ && this.recoverTitleBar_();
    this.player && this.player.dispose();
  },
};
</script>
<style lang="scss">
#videoPLayer {
  position: relative;
  // height: 250px;
  height: 210px;
  transition: all ease-in 0.15s;

  &.fullScreen {
    position: fixed;
    z-index: 2003;
    width: 100vh;
    height: 100vw;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    transform: rotate(90deg) translate3d(calc((100vh - 100vw) / 2), calc((100vh - 100vw) / 2), 0);
  }

  &.fullScreen {
    .vjs-control-custom-full-screen {
      .vjs-icon-placeholder:before {
        background: url("../../assets/images/video/fullscreen2.png") center no-repeat;
        background-size: 14px;
      }
    }
  }

  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 2021;

    &.fullScreen {
      position: absolute;
      width: 100vh;
      height: 100vw;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }

    .time {
      display: inline-block;
      width: 38px;
      height: 70px;
      line-height: 70px;
      font-size: 60px;
      font-weight: 400;
      color: #A291FF;
      text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
      text-align: center;
    }

    .footer {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      margin-top: 22px;

      .btn {
        width: 93px;
        height: 34px;
        line-height: 34px;
        background: #A291FF;
        border-radius: 6px;
        opacity: 0.61;
        font-size: 14px;
        font-weight: 400;
        color: #FFF;
        text-align: center;
        margin-right: 12px;

        &:nth-last-child(1) {
          margin-right: 0;
        }
      }
    }
  }

  .wrap {
    position: absolute;
    // top: 50%;
    // position: absolute;
    // top: 0;
    // left: 0;
    // width: 100%;
    // height: 100%;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
    // z-index: 2021;
    // &.fullScreen {
    //   position: absolute;
    //   width: 100vh;
    //   height: 100vw;
    //   top: 0;
    //   right: 0;
    //   bottom: 0;
    //   left: 0;
    // }
    // .pause {
    // position: absolute;
    // top: -120px;
    // left: 160px;
    // width: 50px;
    // height: 50px;
    // border-radius: 50%;
    // background: url('../../assets/images/parent-course/video.png') no-repeat;
    // background-size: contain;
    // }
    // p{
    // margin-top: 14px;
    // height: 29px;
    // background-color: #fff;
    // border-radius: 4px;
    // text-align: center;
    // opacity: .69;
    // line-height: 29px;
    // color: #ff8340;
    // font-size: 12px;
    // width: 196px;
    // padding: 0px 12px;
    // }
    .net_error {
      width: 96px;
      display: flex;
      align-items: center;
      flex-direction: column;

      .desc_1 {
        height: 22px;
        line-height: 22px;
        color: #FFF;
        font-size: 16px;
      }

      .desc_2 {
        position: relative;
        margin-top: 8px;
        font-size: 12px;
        color: #FF8340;

        &::before {
          position: absolute;
          top: 50%;
          left: -16px;
          transform: translateY(-50%);
          width: 14px;
          height: 14px;
          content: '';
          background: url('../../assets/images/parent-course/refresh1.png') no-repeat;
          background-size: contain;
        }
      }
    }

    .net_status {
      .container {
        position: relative;
        display: flex;
        align-items: center;
        width: 315px;
        height: 177px;
        background-color: #FFF;
        border-radius: 16px;
        // border: 1px solid red;
        .inner_container {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;

          .top_part {
            width: 240px;
            height: 97px;
            // border: 1px solid blue;
            .title {
              color: #666;
              font-size: 14px;
            }

            .title_1 {
              ::v-deep .van-checkbox__icon .van-icon {
                line-height: 1 !important;
              }

              display: flex;
              justify-content: center;
              align-items: center;
              margin-top: 16px;

              .tip {
                text-align: center;
                font-size: 12px;
                height: 17px;
                line-height: 17px;
                width: 132px;
                color: #666;
                margin-left: 3px;
              }
            }
          }

          .bot_part {
            // border: 1px solid red;
            display: flex;
            height: 50px;
            position: absolute;
            line-height: 50px;
            bottom: 0;
            // margin-top: 5;
            .close, .next {
              width: 158px;
              font-size: 14px;
              text-align: center;
            }

            .close {
              border-radius: 0px 0px 0px 16px;
              color: #666;
              background-color: #F2F2F2;
            }

            .next {
              border-radius: 0px 0px 16px 0px;
              color: #FFF;
              background-color: #FF8400;
            }
          }
        }
      }
    }
  }

  .consume {
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 15px;
    margin-top: -25px;
    width: 140px;
    height: 50px;
    z-index: 2022;
    font-size: 16px;
    font-weight: 700;
    color: #A291FF;
    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
  }

  .video-player-box {
    width: 100%;
    height: 100%;
  }

  .video-js .vjs-control-bar {
    background: transparent;
  }

  .video-js .vjs-duration,
  .vjs-no-flex .vjs-duration {
    display: block;
  }

  .video-js .vjs-current-time,
  .vjs-no-flex .vjs-current-time {
    display: block;
  }

  .video-js .vjs-slider {
    height: 2px;
    background-color: white;

    .vjs-load-progress {
      background-color: white;
    }
  }

  .vjs-play-progress.vjs-slider-bar::before {
    top: -6px;
    color: #FFF;
    font-size: 14px;
  }

  .video-js .vjs-play-progress {
    background-color: #FF8340;
  }

  .vjs-big-play-button {
    width: 45px;
    height: 45px;
    border: 0;
    border-radius: 50%;
  }

  .vjs-big-play-centered .vjs-big-play-button {
    margin-top: initial;
    margin-left: initial;
    transform: translate(-50%, -50%);
  }

  .vjs-paused .vjs-big-play-button,
  .vjs-paused.vjs-has-started .vjs-big-play-button {
    display: block;
  }

  .video-js .vjs-tech {
    pointer-events: none;
  }

  .vjs-has-started {
    .vjs-big-play-button {
      display: none !important;
    }
  }

  .vjs-user-active.vjs-has-started,
  .vjs-has-started.vjs-paused {
    .vjs-title-bar {
      display: flex;
    }
  }

  //.vjs-has-started.vjs-paused{
  //  .vjs-control-bar{
  //    display: flex;
  //    opacity: 1;
  //  }
  //}

  .vjs-user-inactive {
    .vjs-title-bar {
      display: none;
    }
  }

  .vjs-current-time-display {
    font-size: 12px;
  }

  .vjs-duration-display {
    font-size: 12px;
  }

  .vjs-title-bar {
    position: relative;
    box-sizing: content-box;
    display: flex;
    height: 30px;
    align-items: center;
    padding: 15px;
    justify-content: space-between;

    .vjs-title-bar-left-wrap {
      flex: 1;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .vjs-title-bar-left-icon {
      width: 8px;
      height: 13px;
      display: inline-block;
      background: url("../../assets/images/video/left.png") center no-repeat;
      background-size: 8px 13px;
      margin-right: 6px;
    }

    .vjs-title-bar-left-text {
      font-size: 14px;
      font-weight: 400;
      color: #FFF;
      line-height: 20px;
    }
  }

  .vjs-custom-percent {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 18px;
    transform: translate(-50%, -50%);

    > span {
      font-size: 16px;
      font-weight: 400;
      color: #FFF;
      line-height: 22px;
    }

    .vjs-custom-percent-inner-cur {
      color: #A291FF;
    }
  }

  .vjs-scrubbing {
    .vjs-custom-percent {
      display: block;
    }
  }

  //.vjs-icon-fullscreen-enter:before, .video-js .vjs-fullscreen-control .vjs-icon-placeholder:before
  .vjs-control-custom-full-screen {
    display: none;

    .vjs-icon-placeholder:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url("../../assets/images/video/fullscreen.png") center no-repeat;
      background-size: 16px 15px;
    }
  }

  .dn {
    display: none;
  }

  .hideLeftIcon {
    .vjs-title-bar-left-icon {
      display: none;
    }
  }
}
</style>
